module.exports = __webpack_public_path__ + "img/contacts-mobile.dc07c67a.png";